import { InputLabel, Theme } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import AttributeFieldActions from "../../attributeMetadata/AttributeFieldToggle";
import { useFormHandlerContext } from "../../../../controllers/formController";
import { useInputFullName } from "../../fields/subForms/NamePrefixContext";
import FieldAnchorLink from "./FieldAnchorLink";
import { getFieldAnchorId } from "../../../../common/fieldAnchorUtils";

interface FormLabelProps {
  name?: string;
  htmlFor?: string;
  required?: boolean;
  label: string;
  actions?: React.ReactNode;
  leading?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const FormLabel: React.FC<FormLabelProps> = ({
  name,
  htmlFor,
  required,
  label,
  actions,
  leading,
  sx,
}) => {
  const { hasMetadataField } = useFormHandlerContext();
  const fullName = useInputFullName(name);

  return (
    <Box
      className="field-label-container"
      id={getFieldAnchorId(fullName)}
      sx={{ display: "flex", alignItems: "baseline", width: "100%" }}
      mb={1}
    >
      {leading && <Box sx={{ mr: 1 }}>{leading}</Box>}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexGrow: 1 }}>
        <InputLabel
          required={required}
          htmlFor={htmlFor || fullName}
          sx={{ lineHeight: 1, ...sx }}
          id={`${fullName}-label`}
        >
          {label}
        </InputLabel>
        <FieldAnchorLink fieldName={fullName} />
      </Box>
      {actions}
      {hasMetadataField(fullName) && <AttributeFieldActions name={fullName} />}
    </Box>
  );
};

export default FormLabel;
